<header class="app-header">

  <h1 class="logo">
    <a href="https://www.exostar.com/" target="_blank" rel="noopener">
      @if (logo()) {
        <img [src]="logo()" alt="Exostar - Supplier Management">
      } @else {
        <img src="../../../assets/images/getlogo.png" alt="Exostar - Supplier Management">
      }
    </a>
    <a [routerLink]="homeUrl">
      <span class="application-title">{{ applicationName() }}</span>
    </a>
  </h1>

  @if (userDetails && !isTcRoute()) {
    <nav class="glob-nav">
      <ul>
        <li class="help">
          <a [routerLink]="homeUrl"><i class="fa fa-home"></i>&nbsp;<span>Home</span></a>
        </li>
        <li class="help">
          <a [href]="myExostarUrl()" target="_blank" rel="noopener"><span>myExostar</span></a>
        </li>
        <li class="help">
          <a [href]="'mailto:' + contactUsEmail()"><span>Contact Us</span></a>
        </li>

        @if (roleContext === userRoleContext.Supplier) {
          <li class="help">
            <a href="https://www.myexostar.com/?ht_kb=onboarding-module-training-resources" target="_blank" rel="noopener">
              <span>Help</span>
            </a>
          </li>
        }

        <li class="welcome-user dropdown">
          <i class="fa fa-user-circle ellipse1"></i>
          <a href="javascript:void(0)" (click)="toggleDropdown()" aria-haspopup="true" [attr.aria-expanded]="showDropdown()">
            <p>
              {{ userDetails.userName }}
              <i class="fa-solid fa-caret-down caret"></i>
              <i class="fa fa-lock profile-2fa" title="Elevated Credential"></i>
            </p>
            <span class="userinfo-spacing">{{ roleDisplayName() }}</span>
          </a>

          @if (showDropdown()) {
            <ul class="welcome-user-drop">
              <li>
                <a [routerLink]="['/user-profile', userDetails.userId]" (click)="toggleDropdown()">My Profile</a>
              </li>
              <li>
                <a href="javascript:void(0)" (click)="confirmSignout()">Logout</a>
              </li>
            </ul>
          }
        </li>
      </ul>
    </nav>
  }

</header>
